<template>
  <el-table-column
    prop="storage.name"
    sortable="custom"
    label="Szállító raktár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.storage_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'storage.name',
  };
</script>
